<script>
    import { PUBLIC_BASE_URL } from "$env/static/public";
    export let host = PUBLIC_BASE_URL;

    const json = {
        "@context": "http://schema.org",
        "@type": "WebSite",
        url: host,
        name: "Nylanders Mattor",
        alternateName: "Nylandersmattor.se",
        potentialAction: {
            "@type": "SearchAction",
            target: host + "sok-mattor?s={search_term_string}",
            "query-input": "required name=search_term_string",
        },
    };
    const jsonld = `<script type="application/ld+json">${JSON.stringify(json) + "<"}/script>`;
</script>

{@html jsonld}
